<template>
    <!-- Main Wrapper -->
    <div class="main-wrapper">
        <layouts></layouts>
        <sidebar-menu></sidebar-menu>
        <div class="page-wrapper">
            <div class="content">
                <pageaddheader :title="title" :title1="title1" />
                <!-- /product list -->
                <div class="card">
                    <div class="card-body">
                        <div class="table-top">
                            <div class="search-set">
                                <!-- <div class="search-path">
                                    <a class="btn btn-filter" id="filter_search" v-on:click="filter = !filter"
                                        :class="{ setclose: filter }">
                                        <img src="../../../assets/img/icons/filter.svg" alt="img" />
                                        <span><img src="../../../assets/img/icons/closes.svg" alt="img" /></span>
                                    </a>
                                </div> -->
                                <div class="search-input">
                                    <a class="btn btn-searchset"><img src="../../../assets/img/icons/search-white.svg"
                                            alt="img" /></a>
                                    <div id="DataTables_Table_0_filter" class="dataTables_filter">
                                        <label>
                                            <input type="search" class="form-control form-control-sm"
                                                placeholder="Search..." aria-controls="DataTables_Table_0" />
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="wordset">
                                <ul>
                                    <li>
                                        <a data-bs-toggle="tooltip" data-bs-placement="top" title="pdf"><img
                                                src="../../../assets/img/icons/pdf.svg" alt="img" /></a>
                                    </li>
                                    <li>
                                        <a data-bs-toggle="tooltip" data-bs-placement="top" title="excel"><img
                                                src="../../../assets/img/icons/excel.svg" alt="img" /></a>
                                    </li>
                                    <li>
                                        <a data-bs-toggle="tooltip" data-bs-placement="top" title="print"><img
                                                src="../../../assets/img/icons/printer.svg" alt="img" /></a>
                                    </li>
                                </ul>
                            </div> -->
                        </div>
                        <!-- /Filter -->
                        
                        <!-- /Filter -->
                        <div class="table-responsive">
                            <a-table :columns="columns" :data-source="data" @change="onChange">
                                <template #bodyCell="{ column, record }">
                                    <template v-if="column.key === 'no'">
                                        <div class="productimgname">
                                            {{ record.no }}
                                        </div>
                                    </template>
                                    <template v-if="column.key === 'id'">
                                        <div class="productimgname">
                                            <a href="javascript:void(0);" class="product-img">
                                                <img :src="record.logo" alt="product" />
                                            </a>
                                            <a href="javascript:void(0);">{{ record.name }}</a>
                                        </div>
                                    </template>
                                    <template v-else-if="column.key === 'action'">
                                        <!-- <a class="me-3" @click="show_izitoast">
                                            <img src="../../../assets/img/icons/eye.svg" alt="img" />
                                        </a> -->
                                        <button type="button" class="me-3 btn " @click="edit(record);">
                                            <img src="../../../assets/img/icons/edit.svg" alt="img" />
                                        </button>
                                        <!-- <a class="confirm-text" href="javascript:void(0);"
                                            @click="terminate(record.id); showModal('terminate');">
                                            <img src="../../../assets/img/icons/delete.svg" alt="img" />
                                        </a> -->
                                    </template>
                                </template>
                            </a-table>
                        </div>
                    </div>
                </div>
                <!-- /product list -->
            </div>
        </div>
    </div>
    <!-- <button type="button" class="btn btn-primary" @click="">
        Launch demo modal
    </button> -->

    
</template>
<script>

import Cookies from "js-cookie";
import axios from "axios";
import { base_url, AlertPopup2, AlertBottom, appendForm, timeout, selectedBranch, goPage } from "@/assets/js/function";
import { watch } from "vue";

export default {
    data() {
        return {
            filter: false,
            title: "Connected Apps List",
            title1: "Manage connected apps",
            items: [
                {
                    text: "Add New Location",
                    addname: "/addlocation",
                },
            ],
            Product: ["Choose Product", "Macbook pro", "Orange"],
            Category: ["Choose Sub Category", "Computer"],
            Choose: ["Choose Category", "Computers", "Fruits"],
            Brand: ["Brand", "N/D"],
            Price: ["Price", "150.00"],

            //data
            data: [


            ],
            currentData: [],
            columns: [
                {
                    title: "No",
                    dataIndex: "no",
                    key: "no",
                    sorter: {
                        compare: (a, b) => {
                            a = a.no.toLowerCase();
                            b = b.no.toLowerCase();
                            return a > b ? -1 : b > a ? 1 : 0;
                        },
                    },
                },
                {
                    title: "Name",
                    dataIndex: "name",
                    key: "id",
                    sorter: {
                        compare: (a, b) => {
                            a = a.name.toLowerCase();
                            b = b.name.toLowerCase();
                            return a > b ? -1 : b > a ? 1 : 0;
                        },
                    },
                },

                {
                    title: "Action",
                    key: "action",
                    sorter: false,
                },
            ],

            jumlah_lokasi: "",

            tanggal_terminate: "",
            alasan_terminate: "",
            id_terminate: "",
        };
    },
    created() {
        const token = Cookies.get("token_refresh");
        this.config = {
            headers: { Authorization: `Bearer ` + token },
            timeout: 30000,
        }
        

        const branch = parseInt(localStorage.getItem("selectedBranch")) || 0;

        //Update local and shared state
        this.filter = branch;
        selectedBranch.value = branch;

        localStorage.setItem('actionState', 'view')

        this.index();
    },

    mounted() {

        watch(selectedBranch, () => {
            this.index()
        }, { immediate: true })
    },

    methods: {
       
        showModal(modal_name) {
            this.$refs[modal_name].classList.add('show');
            this.$refs[modal_name].style.display = 'block';
        },

        hideModal2(modal_name) {
            this.$refs[modal_name].classList.remove('show');
            this.$refs[modal_name].style.display = 'none';

        },
        async cekStatus() {
            
            let formData = new FormData();
            appendForm(formData)
            
            // for (let [key, value] of formData.entries()) {
            //     console.log(key, value);
            // }
            // return;

            const api = this.currentData.callback_status;
            const res = await axios.post(api, formData, { timeout });
            const data = res.data;
            console.log('ini response cek status:', data);
            
            if(data.status){

                goPage('editconnectedapps');
                

            }else {
                AlertPopup2("error", "", data.data.message, true, 1500);
            }

            

           
        },


       

        async index() {
           
            let formData = new FormData();
            appendForm(formData)

            const api = base_url + '/v3/applications/index';
            const res = await axios.post(api, formData, { timeout });
            const data = res.data;
            console.log('ini response', data);
            
            if(data.status){

                const connectApps = data.data.data_application.application

                this.data = [];
                connectApps.forEach((item, index) => {
                    let item_prepare = { ...item, no: (index + 1), };
                    this.data.push(item_prepare);
                });

            }else {
                AlertPopup2("error", "", data.message, true, 1500);
            }

           

        },

        edit(record) {
            localStorage.setItem('currentData', JSON.stringify(record));
            this.currentData = record;
            if (this.currentData.callback_register == undefined) {
                this.cekStatus();
            } else {
                goPage('editconnectedapps');
            }
        },
        
    },
    name: "productlist",
};
</script>
<style>
.ant-tooltip {
    display: none !important;
}
</style>